import React from 'react';
import { emptyNfPurchaseQtyMeta } from './nfPurchaseQtyMeta';

/**
 * Dual bottles/cans/barrels + litres (or kg) when packing size is known; otherwise one labeled quantity field.
 * Canonical stored value remains input#quantity (packs).
 */
const NfPurchaseQuantityFields = ({
  idx,
  isNfStockUpVendor = false,
  meta,
  defaultQuantity = undefined,
  defaultLitres = undefined,
  error,
  litresError,
  onQuantityChange,
  onLitresChange,
  prevNonNumericalWithDec,
  preventNonNumericalInput,
}) => {
  const lineMeta = meta || emptyNfPurchaseQtyMeta();
  const dual = Boolean(lineMeta.supports_dual_qty && Number(lineMeta.pack_size) > 0);
  const volumeUnit = lineMeta.pack_volume_unit || 'L';
  const volumeLabel = volumeUnit === 'Kg' ? 'Kg' : 'Litres';
  const packLabel = isNfStockUpVendor ? 'Stockup' : 'Purchase';
  const singleLabel = `${packLabel} Quantity (${lineMeta.purchase_unit_label || 'Pieces'})`;
  const dualPackLabel = lineMeta.purchase_unit_label || 'Bottles/Cans';
  const qtyLabel = dual ? `${packLabel} Quantity (${dualPackLabel})` : singleLabel;

  const qtyValueProps = defaultQuantity !== undefined ? { defaultValue: defaultQuantity } : {};
  const litresValueProps = defaultLitres !== undefined ? { defaultValue: defaultLitres } : {};

  // Dual pack field: whole numbers only; single-field quantity may still allow decimals.
  const onPackKeyPress = dual && preventNonNumericalInput
    ? (event) => preventNonNumericalInput(event, event.target.value)
    : (event) => prevNonNumericalWithDec(event, event.target.value);

  return (
    <>
      <input type="hidden" id={`pack_size${idx}`} name="pack_size" value={dual ? lineMeta.pack_size : 0} readOnly />
      <div className="row g-3 justify-content-center mb-2">
        <div className="col-4">
          <label className="col-form-label">{qtyLabel}<sup className="star">*</sup></label>
        </div>
        <div className="col-6">
          <input
            type="number"
            className="form-control hide-arrow"
            onKeyPress={onPackKeyPress}
            name="quantity"
            id={`quantity${idx}`}
            step={dual ? '1' : 'any'}
            {...qtyValueProps}
            onChange={(event) => onQuantityChange(idx, event)}
          />
          <div className="errorMsg">{error}</div>
          {dual && lineMeta.pack_size_hint ? (
            <div className="small text-muted mt-1">{lineMeta.pack_size_hint}</div>
          ) : null}
        </div>
        <div className="col-2" />
      </div>
      <div className={`row g-3 justify-content-center mb-2${dual ? '' : ' d-none'}`}>
        <div className="col-4">
          <label className="col-form-label">{packLabel} Quantity ({volumeLabel})</label>
        </div>
        <div className="col-6">
          <input
            type="number"
            className="form-control hide-arrow"
            onKeyPress={(event) => (preventNonNumericalInput
              ? preventNonNumericalInput(event, event.target.value)
              : prevNonNumericalWithDec(event, event.target.value))}
            name="quantity_litres"
            id={`quantity_litres${idx}`}
            {...litresValueProps}
            onChange={(event) => onLitresChange(idx, event)}
          />
          <div className="errorMsg">{litresError}</div>
          {dual ? (
            <div className="small text-muted mt-1">
              Enter {String(dualPackLabel).toLowerCase()} or {volumeLabel.toLowerCase()}; both stay linked by packing size.
            </div>
          ) : null}
        </div>
        <div className="col-2" />
      </div>
    </>
  );
};

export default NfPurchaseQuantityFields;
